export const makeBrowserDownload = (urlOrByteFile, filename, type) => {
  const link = document.createElement("a");
  document.body.appendChild(link);
  link.setAttribute("type", "hidden");
  link.href =
    typeof urlOrByteFile === "string" ? urlOrByteFile : window.URL.createObjectURL(new Blob([urlOrByteFile], { type }));
  link.download = filename;
  link.click();
  link.remove();
};

export const getFileNameFromContentDeposition = (response, fallbackFileName) => {
  let fileName = fallbackFileName;
  const disposition = response.headers["content-disposition"];
  if (disposition && (disposition.indexOf("attachment") !== -1 || disposition.indexOf("inline") !== -1)) {
    var matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, "");
    }
  }
  return fileName;
};

export const previewPDF = (byteFile) => {
  previewFile(byteFile, "application/pdf");
};

function previewFile(byteFile, type) {
  const blobFile = new Blob([byteFile], { type });
  const url = window.URL.createObjectURL(blobFile);
  window.open(url, "_blank");
}
